import { Typography } from "@material-ui/core";
import {
  ApplicationCategoryDto,
  GuidepostDto,
  ApplicationCodes,
} from "Api/Api";
import { GuidepostApplication } from "Components/Guidepost/GuidepostApplication";
import { Resources, useResource } from "Translations/Resources";
import * as React from "react";
import styled from "styled-components";

type Props = {
  guidepost: GuidepostDto;
};

const StyledWrapper = styled.div`
  display: grid;
  padding-top: ${props => props.theme.spacing(1.25)}px;
  padding-bottom: ${props => props.theme.spacing(8)}px;
  color: ${props => props.theme.palette.primary.dark};
  border-top: 1px solid ${props => props.theme.colors.border};

  .ibis-guidepost-app {
    padding-left: ${props => props.theme.spacing(2)}px;
  }

  .menu-link {
    &:hover {
      background-color: ${props => props.theme.palette.secondary.light};
    }
  }
`;

const StyledCategoryWrapper = styled.div`
  padding-bottom: ${props => props.theme.spacing(2)}px;

  .menu-link {
    &:hover {
      background-color: ${props => props.theme.palette.secondary.light};
    }
  }
`;

const StyledCategoryName = styled.div`
  h4 {
    font-size: ${props => props.theme.typography.h5.fontSize}px;
    padding: ${props => props.theme.spacing(2, 1, 1, 2)};
    font-weight: 500;
    border-top: 1px solid ${props => props.theme.colors.border};
  }
`;

const Category = (category: ApplicationCategoryDto) => {
  return (
    <StyledCategoryWrapper key={category.category.name}>
      {category.category.name !== "Interní aplikace" && (
        <StyledCategoryName>
          <Typography variant={"h4"}>{category.category.name}</Typography>
        </StyledCategoryName>
      )}
      {category.applications?.map(app => (
        <React.Fragment key={app.applicationCode}>
          <GuidepostApplication application={app} withName logVisit />
        </React.Fragment>
      ))}
    </StyledCategoryWrapper>
  );
};

export const GuidepostCategories: React.FunctionComponent<Props> = props => {
  const { t } = useResource();

  return (
    <StyledWrapper>
      <GuidepostApplication
        key={ApplicationCodes.Dashboard}
        withName
        application={{
          applicationCode: ApplicationCodes.Dashboard,
          name: t(Resources.MenuItems.Dashboard),
          url: `/${t(Resources.Routes.Dashboard)}`,
          imageUri: "",
        }}
        logVisit={false}
      />
      {props.guidepost &&
        props.guidepost.categories &&
        props.guidepost.categories.map(c => Category(c))}
    </StyledWrapper>
  );
};
